// If you don't want to use TypeScript you can delete this file!
import React, { useContext, useEffect } from "react";
import { PageProps, graphql, navigate } from "gatsby"
import { ChakraProvider, Flex, Box, Container, Image } from "@chakra-ui/react";
import CustomFonts from "../components/Layout/CustomFonts";
import Seo from "../components/seo"
import { CustomTheme } from "../components/Layout/CustomTheme";
import { IdentityContext } from '../context/identity';


type DataProps = {
	site: {
		buildTime: string
	}
}

const UsingTypescript: React.FC<PageProps<DataProps>> = ({ data, path }) => {
	const { authUser } = useContext(IdentityContext);

	useEffect(() => {
		if (!authUser) {
			navigate('/login');
		} else {
			navigate('/dashboard');
		}
	}, [])

	return (

		<ChakraProvider theme={CustomTheme}>
			<CustomFonts />
			<Seo title="Cargando..." />
			<Flex
				w='full'
				background='blue.700'
				backgroundImage={{ base: "none", sm: "none", md: "url('/static/images/bg_login@2x.png')", lg: "url('/static/images/bg_login@2x.png')" }}
				backgroundPosition="top left"
				backgroundRepeat="no-repeat"
				bgSize='cover'
				bgAttachment="fixed"
			>
				<Box
					w='full'
					minHeight="100vh">
					<Container
						display='flex'
						alignItems='center'
						justifyContent='center'
						maxW="full"
						py={{ base: 12, sm: 12, md: 16, lg: 16 }}>
						<Box maxW='400' alignItems='center' justifyContent='center' display='block' pt={{ base: 12, sm: 12, md: 56, lg: 56 }}>
							<Image src="/static/images/loader_pikkop.gif" />
						</Box>
					</Container>
				</Box>
			</Flex>
		</ChakraProvider>
	)
}

export default UsingTypescript

export const query = graphql`
  {
    site {
      buildTime(formatString: "YYYY-MM-DD hh:mm a z")
    }
  }
`
